module.controller('list', function(xmppAuth, services, $scope, $mdDialog, $window, theme, $localStorage, APIKeyGooglePlaces, cryptool) {

  var xmpp_domain = cryptool.decryptData($window.sessionStorage.getItem("serviceName"));
  var xmppUser = $window.sessionStorage.getItem('userXmpp');
  
  $scope.showList = true
  if($window.localStorage.getItem('ismetadaDynamicForm') && $window.localStorage.getItem('ismetadaDynamicForm') === 'true')
    $scope.optionList = JSON.parse($window.localStorage.getItem('metadataObjToForm'));
  else{
   $scope.optionList = JSON.parse($window.localStorage.getItem("metadataObj"));
  }
  $scope.showList = !($scope.optionList.instruction &&  $scope.optionList.instruction.hideList)
  $scope.title = "Selecciona una opción";
  if($scope.optionList.instruction &&  $scope.optionList.instruction.title) {
    $scope.title = $scope.optionList.instruction.title;
  }
  $scope.pressKey = function(){
    if($scope.search!=null && $scope.search.length >= 1) {
      $scope.showList = true 
    } else {
      $scope.showList = false 
    }
  }
    

  
  $scope.theme = theme.getTheme();
  
  $scope.closeDialog = function(){
    $window.localStorage.removeItem('ismetadaDynamicForm');
    $window.localStorage.removeItem('metadataObjToForm');
    $mdDialog.cancel();
  };

  $scope.selected = [];

  $scope.toggle = function (item, list) {
       var idx = list.indexOf(item);
       if (idx > -1)
         list.splice(idx, 1);
       else {
         $scope.selectedItem = true;
         list.push(item);
       }

       if(list.length == 0)
         $scope.selectedItem = false;
    };

   $scope.exists = function (item, list) {
     return list.indexOf(item) > -1;
   };



   function onPositionUpdate(position, msg) {
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    var location = {};
    var url = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + lat + "," + lng + "&key=" + APIKeyGooglePlaces + "&&sensor=true&callback=initMap";
    fetch(url)
    .then(response => response.text())
    .then(contents => {
      var data = JSON.parse(contents);

      if (data.results[0]) {
            location.longitude = lng.toString();
            location.latitude = lat.toString();
            //location.label = lat.toString();
            location.addressLine = data.results[0].formatted_address;
            location.label = msg.id;
             for(var i=0; i<data.results[0].address_components.length; i++)
             {
               if(data.results[0].address_components[i].types[0] == "administrative_area_level_2")
                  location.locality = data.results[0].address_components[i].long_name;
               if(data.results[0].address_components[i].types[0] == "postal_code")
                  location.postalCode = data.results[0].address_components[i].long_name;
               if(data.results[0].address_components[i].types[0] == "country"){
                 location.country = data.results[0].address_components[i].short_name;
                 location.countrycode = data.results[0].address_components[i].short_name;
                 location.identifier = 0;
               }
            }
            services.userLocation('bearer ' + $window.localStorage.getItem('access_token1')).request({}, location,  function(status, response) {
                $scope.progressCircular = undefined;
                $mdDialog.cancel();
                meta = JSON.parse($window.sessionStorage.getItem("confirmDialog"));
                if(meta && meta.confirmation) {         
                    $scope.pendingMessage = msg;                            
                    $scope.showConfirmation(); 
                    $scope.pendingSend = function() {
                      xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, $scope.pendingMessage.id, $scope.pendingMessage.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);                         
                      $localStorage.typeSelect = "value";
                    }               
                } else {
                  xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, msg.id, msg.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);                         
                  $localStorage.typeSelect = "value";
                }
            });
        }
    })
    .catch(() => console.log("Can’t access " + url + " response. Blocked by browser?"))
  }

  function sendMessage(msg){
    $mdDialog.cancel();     
    meta = JSON.parse($window.sessionStorage.getItem("confirmDialog"));
    if(meta && meta.confirmation) {         
        $scope.pendingMessage = msg;                            
        $scope.showConfirmation(); 
        $scope.pendingSend = function() {
          xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, $scope.pendingMessage.id, $scope.pendingMessage.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);                         
          $localStorage.typeSelect = "value";
        }               
    } else {
      xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, msg.id, msg.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);                         
      $localStorage.typeSelect = "value";
    }

  }

  $scope.requestLocation = function(msg){
    $scope.progressCircular = "ok";
    
    if(navigator.geolocation){
      var messageRequestLocation = "Estimado usuario, los permisos de ubicación son necesarios para una mejor experiencia en la solicitud de créditos.";
      var confirm = $mdDialog.confirm()
  .title('Notificación')
  .htmlContent(messageRequestLocation)
  .ariaLabel('Lucky day')
  .ok('Ok');

  var showLockMessage = false;

  if(!$window.localStorage.getItem("locationPermission")){
        
      $mdDialog.show(confirm);   
  }
  else{
    if( $window.localStorage.getItem("locationPermission") && $window.localStorage.getItem("locationPermission") === 'lock')
      showLockMessage = true;
  }


      navigator.geolocation.getCurrentPosition(function(position){
        $window.localStorage.setItem("locationPermission", "true");
      
        onPositionUpdate(position, msg);
        $scope.progressCircular = undefined;

      },
      function(err){
        $scope.progressCircular = undefined;
        switch (err.code) {
          // PERMISSION_DENIED
          case 1:
            console.log('Permission denied')
            $window.localStorage.setItem("locationPermission", "lock");               
            break
          // POSITION_UNAVAILABLE
          case 2:
            console.log('Permission allowed, location disabled')
            break
          // TIMEOUT
          case 3:
            console.log('Permission allowed, timeout reached')
            break
        }
        sendMessage(msg);
      }
      );
    }
    else{
      $scope.progressCircular = undefined;
      sendMessage(msg);

    } 
  }

  $scope.sendMsgList = function(msg, label) {
      if(label === "locationSelect")
          $scope.requestLocation(msg);
      else { 
        var meta = JSON.parse($window.sessionStorage.getItem("confirmDialog"));
        if(meta && meta.confirmation) {         
            $scope.pendingMessage = msg;
            $mdDialog.cancel();
            $scope.showConfirmation(); 
            $scope.pendingSend = function() {
              xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, $scope.pendingMessage.id, $scope.pendingMessage.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);                            
              $localStorage.typeSelect = "value";
            }               
        } else {
            xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, msg.id, msg.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
            $mdDialog.cancel();
            $localStorage.typeSelect = "value";
        }
      }
  };
  $scope.pendingSend = function(){};
  $scope.sendMsgListCheckbox = function(msg) {
      var data = {};
      if(msg.length > 0){
        console.log(msg);
        data.id = msg[0].id.toString();
        data.value = msg[0].value.toString();
        for(var i=1; i<msg.length; i++){
            data.id = data.id +','+ msg[i].id;
            data.value = data.value +', '+ msg[i].value;
        }
        
        meta = JSON.parse($window.sessionStorage.getItem("confirmDialog")); 
        if(meta && meta.confirmation && $window.localStorage.getItem('ismetadaDynamicForm')==null) {         
            $scope.pendingMessage = data;
            $mdDialog.cancel();
            $scope.showConfirmation();
            
            if($window.localStorage.getItem('ismetadaDynamicForm') && $window.localStorage.getItem('ismetadaDynamicForm') === 'true'){
              $window.localStorage.removeItem('ismetadaDynamicForm');
              $window.localStorage.removeItem('metadataObjToForm');              
              $mdDialog.hide(data);
            }
            else{
              $scope.pendingSend = function() {
                xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, $scope.pendingMessage.id, $scope.pendingMessage.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
                $window.localStorage.removeItem('ismetadaDynamicForm');
              $window.localStorage.removeItem('metadataObjToForm');
                $mdDialog.cancel();
                $localStorage.typeSelect = "value";
              }       

            }
            
            
        } else {

          if($window.localStorage.getItem('ismetadaDynamicForm') && $window.localStorage.getItem('ismetadaDynamicForm') === 'true'){
            $window.localStorage.removeItem('ismetadaDynamicForm');
            $window.localStorage.removeItem('metadataObjToForm');            
            $mdDialog.hide(data);


          }
          else{
              xmppAuth.Chat.sendMessage(xmppUser+"@"+xmpp_domain, data.id, data.value, "sent", "REPLY", $window.sessionStorage.getItem('idAga'), xmpp_domain);
              $window.localStorage.removeItem('ismetadaDynamicForm');
                  $window.localStorage.removeItem('metadataObjToForm');
              $mdDialog.cancel();
              $localStorage.typeSelect = "value";

          }
        }
        
      }
  };

  
  $scope.showConfirmation = function(ev) {   
    var confirmDialog =  JSON.parse($window.sessionStorage.getItem("confirmDialog")); 
    confirmDialog.response = $scope.pendingMessage.value;
    $window.sessionStorage.setItem("confirmDialog", JSON.stringify(confirmDialog));       

    var confirm = $mdDialog.show({
        controller: 'confirmationCntrl',
        templateUrl: './views/dashboard/confirmation.html',
        parent: angular.element(document.body),
        targetEvent: ev
    }).then(function(answer) {
            $scope.pendingSend();
      }, function() {
          
    });

  };


  $scope.msgToast = function(message, type){
    $mdToast.show(
        $mdToast.simple()
        .textContent(message)
        .position('top')
        .action('Ok')
        .theme(type)
        .hideDelay(2000)
    );
  };
});
